<template>
	<div>
		<div class="product-register__excel">
			<input
				type="file"
				id="file"
				@change="excelUpload"
				style="display: none"
				accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			/>
			<label for="file" class="btn-excel blue upload">엑셀 업로드</label>
			<p class="product-register__notice">
				엑셀 업로드는 신규 제품 한 건만 가능합니다. 일괄 업로드는 제품
				리스트에서 진행해주세요.
			</p>
		</div>
		<form id="product-register-form" @submit.prevent="register">
			<ProductController ref="controller" />
		</form>
		<div class="btn-wrap-main">
			<button
				class="btn-main blue bordered"
				type="button"
				v-text="'취소'"
				@click="$refs.controller.refresh()"
			/>
			<button
				form="product-register-form"
				type="submit"
				class="btn-main blue"
				v-text="'등록'"
			/>
		</div>
		<div class="product-register__complete-box" v-if="registerComplete">
			<div class="product-register__complete-box__box">
				<button
					class="btn-main blue bordered"
					type="button"
					@click="toList"
				>
					검색 화면으로
				</button>
				<button class="btn-main blue" type="button" @click="toRegister">
					다른 제품 등록
				</button>
				<button
					class="btn-main blue bordered"
					type="button"
					@click="toRegisterProduct"
				>
					등록 제품 보기
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ProductController from '@/components/product/ProductController.vue';
	import * as XLSX from 'xlsx';

	export default {
		name: 'ProductRegister',
		components: { ProductController },
		computed: {
			...mapState('ProductController', [
				'primarySecondCategoryIdx',
				'registerComplete',
				'idProduct',
			]),
		},
		async created() {
			await this.$store.commit('ProductController/init');
			await this.$store.commit('ProductController/togglePageType', false);
		},
		methods: {
			async register() {
				try {
					const categorySelector =
						this.$refs.controller.$refs.categorySet.$refs
							.categorySelector;
					let categoryMappings = null;
					if (categorySelector && categorySelector.length > 0) {
						categoryMappings = categorySelector.map(
							(component, idx) => {
								const obj = {
									idFirstCategory: component.category1,
									idSecondCategory: component.category2,
									idThirdCategory: component.category3,
								};
								if (idx === this.primarySecondCategoryIdx)
									obj.isPrimary = true;
								return obj;
							}
						);
					}
					const result = await this.$store.dispatch(
						'ProductController/register',
						{ categoryMappings, isRegister: true }
					);
					if (!result) return;
					alert(
						typeof result === 'string'
							? result
							: '등록이 완료되었습니다.'
					);
					this.$store.commit('ProductController/stateChange', [
						{ key: 'registerComplete', value: true },
					]);
				} catch (err) {
					console.error(err);
				}
			},
			toList() {
				this.$router.push('/product/product-list');
			},
			toRegister() {
				window.location.reload();
			},
			toRegisterProduct() {
				this.$router.push(`/product/product-inquiry/${this.idProduct}`);
			},
			mutationSingle(key, value) {
				this.$store.commit('ProductController/stateChange', [
					{ key, value },
				]);
			},
			initData(data) {
				Object.entries(data).forEach(([key, value]) => {
					this.mutationSingle(key, value);
				});
			},
			excelUpload(event) {
				const init = {
					productTitle: '',
					colorType: '',
					productText: '',
					volume: '',
					price: '',
					releaseDate: '',
				};
				this.initData(init);
				const files = event.target.files;
				if (files.length === 0) return;

				const file = files[0];
				const reader = new FileReader();

				reader.onload = e => {
					const data = e.target.result;
					const workbook = XLSX.read(data, { type: 'binary' });

					const firstSheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[firstSheetName];
					const jsonData = XLSX.utils.sheet_to_json(worksheet);

					const trueLength = jsonData.filter(item => {
						return typeof item.__EMPTY === 'number';
					}).length;

					if (trueLength === 0) {
						//단건 입력시 엑셀파일의 No.의 값은 필수 항목
						alert(
							'입력된 제품이 없습니다. 다시 확인 부탁드립니다. (엑셀파일의 No.는 필수입니다.)'
						);
						return;
					} else if (trueLength > 1) {
						alert('신규제품등록은 한건만 가능합니다.');
						return;
					}

					jsonData.forEach(item => {
						if (typeof item.__EMPTY === 'number') {
							let parts;
							let year;
							let month;
							let formattedDate;

							if (item.__EMPTY_6) {
								const regex = /^\d{6}$/;
								if (regex.test(item.__EMPTY_6)) {
									year = String(item.__EMPTY_6).slice(0, 4);
									month = String(item.__EMPTY_6).slice(4);
									formattedDate = [year, month].join('-');
								} else {
									parts = item.__EMPTY_6?.split('년');
									year = parts[0].trim();
									month = parts[1]
										.replace('월', '')
										.trim()
										.padStart(2, '0');
									formattedDate = `${year}-${month}`;
								}
							} else {
								formattedDate = '';
							}

							const excelUploadData = {
								productTitle: item.__EMPTY_1 ?? '',
								colorType: item.__EMPTY_2 ?? '',
								productText: item.__EMPTY_3 ?? '',
								volume: item.__EMPTY_4 ?? '',
								price: item.__EMPTY_5 ?? '',
								releaseDate: formattedDate ?? '',
							};
							this.initData(excelUploadData);
						}
					});
				};
				reader.readAsBinaryString(file);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.upload {
		margin-top: 20px;
		cursor: pointer;
	}
	.product-register__notice {
		margin-top: 10px;
		color: $red;
	}
	.product-register__complete-box {
		z-index: 9999999999999;
		position: fixed;
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background: rgba(10, 10, 10, 0.86);
		transform: translateZ(0);
	}

	.product-register__complete-box__box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 380px;
		height: 120px;
		background: white;
		border-radius: 4px;
		border: solid 1px #acaeb4;
		font-size: 0;

		.btn-main {
			margin-right: 0;

			&:first-child {
				margin-left: 0;
				margin-right: 10px;
			}
		}
	}
</style>
